export default "__VITE_PUBLIC_ASSET__2d4c0d6d__"